import { render, staticRenderFns } from "./exhibition-info-catalogueAlterEdit.vue?vue&type=template&id=deb6066e&scoped=true&"
import script from "./exhibition-info-catalogueAlterEdit.vue?vue&type=script&lang=js&"
export * from "./exhibition-info-catalogueAlterEdit.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-info-catalogueAlterEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./exhibition-info-catalogueAlterEdit.vue?vue&type=style&index=1&id=deb6066e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb6066e",
  null
  
)

export default component.exports